import React from "react";
import classes from "./banner.module.css";

const banner = () => {
  return (
    <div className={classes.banner}>
      <div className={classes.content}>
        <div className={classes.left}>
          <h1>
            AIQ <span> - ALL INDIA QUOTA</span>
          </h1>
          <p>State Quota, Ayush, Veterinary, Engineering</p>
        </div>

        <div className={classes.right}>
          <p className={classes.tagline}>
         <p className={classes.glowText}> <p className={classes.shineText}> With RCG, Dreams Don’t Get Lost — They Get Direction.</p></p>
          </p>

         <a href="https://wa.me/918446122201"> <button className={classes.cta}>
            Get Free Counselling Now
            <span className={classes.arrow}>↗</span>
          </button></a>
        </div>
      </div>
    </div>
  );
};

export default banner;